import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { BibItem } from '../../providers/item/item';
import { AppState } from '../../config/state';

/**
 * Generated class for the CoCoverFallbackDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[co-cover-fallback]', // Attribute selector
  inputs: ['bib', 'fallback-title']
})
export class CoCoverFallbackDirective {
	@Input() bib: any;
	@Input('fallback-title') fallbackTitle: string;
  element: any;
  constructor(el: ElementRef, private state: AppState) {
	this.element = el;
  }
  ngOnInit() {
	  if(this.bib){
		let server = Math.floor(Math.random() * 9);
		if(this.bib.upcs && this.bib.upcs.length>0){
			// this.element.nativeElement.src = `http://covers${server}.communico.co/upc/o/${this.bib.upcs[0]}.jpg`;
			this.element.nativeElement.src = `https://${this.state.client.keyword}.libnet.info/getcover/${this.bib.upcs[0]}`;
		}else if(this.bib.isbns && this.bib.isbns.length>0){
			// this.element.nativeElement.src = `http://covers${server}.communico.co/isbn/o/${this.bib.isbns[0]}.jpg`
			this.element.nativeElement.src = `https://${this.state.client.keyword}.libnet.info/getcover/${this.bib.isbns[0]}`;
		}else if (this.bib.isbn){
			this.element.nativeElement.src = `https://${this.state.client.keyword}.libnet.info/getcover/${this.bib.isbn.split(' ')[0]}`;
		} else if (this.bib.imageLinks && this.bib.imageLinks.length > 0){
			this.element.nativeElement.src = this.bib.imageLinks[0].url;
		}else{
			this.fallbackImage();
		}
	}
  }
  fallbackImage(){
	  if(this.fallbackTitle){
		this.element.nativeElement.src = `http://covers0.communico.co/gen/cover?title=`+encodeURIComponent(this.fallbackTitle);
	  }else{
		this.element.nativeElement.src = `http://covers0.communico.co/gen/cover?title=`+encodeURIComponent(this.element.nativeElement.title?this.element.nativeElement.title:"No title");
	  }
    return this.element
  }
  @HostListener('error') error($event){
	  return this.fallbackImage();
  }

}



// WEBPACK FOOTER //
// ./src/directives/co-cover-fallback/co-cover-fallback.ts